import { useMemo } from "react";

import { typedQueryClient } from "hooks";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";

import type { WebSocketMessageListener } from "components";
import type { PinPendingChecklist } from "models";

export const usePinChecklistsListeners = () => {
  const listeners = useMemo(() => {
    const pinChecklistsListeners: WebSocketMessageListener<PinPendingChecklist>[] = [
      {
        model: "PinPendingChecklist",
        action: "upsert",
        callback: ({ data: pinPendingChecklist }) => {
          const pinPendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.pinPendingChecklists);

          const pinPendingChecklistIdx =
            pinPendingChecklists?.findIndex(p => p.checklist_id === pinPendingChecklist.checklist_id && p.pin_type === pinPendingChecklist.pin_type) ?? -1;

          const updatePendingChecklists = [...(pinPendingChecklists || [])];

          if (pinPendingChecklistIdx < 0) updatePendingChecklists.push(pinPendingChecklist);
          else updatePendingChecklists[pinPendingChecklistIdx] = { ...updatePendingChecklists[pinPendingChecklistIdx], ...pinPendingChecklist };

          typedQueryClient.setQueryData(PendingChecklistsQueryKeys.pinPendingChecklists, updatePendingChecklists);
        }
      },
      {
        model: "PinPendingChecklist",
        action: "delete",
        callback: ({ data: pinPendingChecklist }) => {
          const pinPendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.pinPendingChecklists);
          if (!pinPendingChecklists || !pinPendingChecklists.length) return;

          const pinPendingChecklistIdx = pinPendingChecklists.findIndex(
            p => p.checklist_id === pinPendingChecklist.checklist_id && p.pin_type === pinPendingChecklist.pin_type
          );
          if (pinPendingChecklistIdx < 0) return;

          typedQueryClient.setQueryData(PendingChecklistsQueryKeys.pinPendingChecklists, pinPendingChecklists.toSpliced(pinPendingChecklistIdx, 1));
        }
      }
    ];

    return [...pinChecklistsListeners];
  }, []);

  return listeners;
};
